import React from 'react'
import styled from 'styled-components'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { withStyles } from '@material-ui/core/styles'
import FbSvg from '/static/images/fb.svg'
import { tabletSize, mobileSize, desktopSize } from 'theme'
import useCanShare from 'hooks/useCanShare'
import useBreakpoint from 'hooks/useBreakpoint'
import { facebookShare } from 'utils/shareUtil'

const CardTabs = withStyles({
  root: {
    borderBottom: '1px solid #e5e5e5',
  },
  indicator: {
    backgroundColor: '#0038e8',
  },
})(Tabs)
const CardTab = withStyles((theme) => ({
  root: {
    minWidth: 72,
    fontSize: 16,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(2),
    color: '#838383',
    '&$selected': {
      color: '#0038e8',
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  selected: {
    color: '#0038e8',
    fontWeight: 500,
  },
}))((props) => <Tab disableRipple {...props} />)

const TabPanel = (props) => {
  const { children, value, index } = props

  return (
    <div
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
    >
      {value === index && children}
    </div>
  )
}

const DetailCard = ({
  showHeader,
  sku,
  SkuTabInfo,
  BaseInfo,
  pageUrl,
  children,
  isFullPage,
}) => {
  const { merchant, tnc } = sku
  const [tabIndex, setTabIndex] = React.useState(0)
  const canShare = useCanShare()
  const { isMobileBreakpoint } = useBreakpoint()

  const handleChange = (event, newValue) => {
    setTabIndex(newValue)
  }

  return (
    <DetailCardWapper>
      {showHeader && (
        <CardHeader
          title={merchant.name}
          merchantLogo={merchant.logo}
          pageUrl={pageUrl}
          canShare={canShare}
          isMobileBreakpoint={isMobileBreakpoint}
        />
      )}
      <BaseInfo></BaseInfo>
      <DetailContentWapper isFullPage={isFullPage}>
        <CardTabContainer>
          <CardTabs
            value={tabIndex}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <CardTab label="優惠詳情" />
            <CardTab label="條款及細則" />
          </CardTabs>
          <TabPanel value={tabIndex} index={0}>
            <TablPanelContainer>
              <SkuTabInfo />
            </TablPanelContainer>
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <TablPanelContainer>
              <TncText>{tnc}</TncText>
            </TablPanelContainer>
          </TabPanel>
        </CardTabContainer>
        {children}
      </DetailContentWapper>
    </DetailCardWapper>
  )
}
const CardHeader = ({ merchantLogo, title, pageUrl }) => {
  const handleFacebookShare = () => {
    facebookShare({
      href: pageUrl,
      success: () => {
        // TODO: track facebook share success e_a:response
      },
      fail: () => {
        // TODO: track facebook share failed e_a:response
      },
    })
  }
  return (
    <HeaderContainer>
      <HeaderWapper>
        <div>
          {merchantLogo && <MerchantLogo src={merchantLogo} />}
          <HeaderTitle>{title}</HeaderTitle>
        </div>
        <ShareWrap
          className="fb-share-button"
          data-href={pageUrl}
          data-layout="button"
          data-lazy={true}
        >
          <ShareContainer onClick={handleFacebookShare}>
            <span>分享:</span>
            <FbSvg />
          </ShareContainer>
        </ShareWrap>
      </HeaderWapper>
    </HeaderContainer>
  )
}
export const SkuInfoRow = ({ title, content, showExpire }) => {
  return (
    <SkuInfoRowWapper>
      <LeftTitle>{title}</LeftTitle>
      <RightContent>
        {content}
        {showExpire && <ExpireLabel>將到期</ExpireLabel>}
      </RightContent>
    </SkuInfoRowWapper>
  )
}

export const DetailCardWapper = styled.div`
  border-radius: 8px;
  width: 100%;
  position: relative;
  z-index: 1;
  @media ${mobileSize} {
    margin-bottom: 56px;
  }
`

export const HeaderContainer = styled.div`
  position: relative;
  border-radius: 8px 8px 0 0;
  mask-image: radial-gradient(circle at right, transparent 8px, black 0),
    radial-gradient(circle at left, transparent 8px, black 0);
  mask-position: left 120px, right 0;
  mask-size: 100% 181%;
  mask-repeat: space;
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    height: 7px;
    border-top: dashed 1px rgba(3, 7, 15, 0.2);
    width: calc(100% - 48px);
    margin: auto;
    z-index: 1;
  }
  @media ${mobileSize} {
    mask-image: radial-gradient(circle at right, transparent 6px, black 0),
      radial-gradient(circle at left, transparent 6px, black 0);
    &:before {
      width: calc(100% - 32px);
    }
  }
`
export const HeaderWapper = styled.div`
  background-color: #fff;
  padding: 24px;
  padding-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  mask-image: radial-gradient(circle at right, transparent 8px, black 0),
    radial-gradient(circle at left, transparent 8px, black 0);
  mask-position: left 0, right 120px;
  mask-size: 100% 181%;
  mask-repeat: space;
  @media ${mobileSize} {
    padding: 16px 8px;
    padding-bottom: 24px;
    mask-image: radial-gradient(circle at right, transparent 6px, black 0),
      radial-gradient(circle at left, transparent 6px, black 0);
  }
`
const MerchantLogo = styled.img`
  border-radius: 50%;
  border: 1px solid ${(p) => p.theme.color.grey80};
  height: 32px;
  width: 32px;
  object-fit: contain;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
`

const HeaderTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: ${(p) => p.theme.color.navigationTitleColor};
  display: inline-block;
  vertical-align: middle;
`
const ShareWrap = styled.div`
  cursor: pointer;
  display: none;
  @media ${desktopSize} {
    display: block;
  }
  span {
    width: 36px;
    font-size: 14px;
    padding-right: 16px;
    color: ${(p) => p.theme.color.navigationTitleColor};
    @media ${mobileSize} {
      padding-right: 8px;
    }
  }
`

const ShareContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
`
const DetailContentWapper = styled.div`
  border-radius: 0 0 8px 8px;
  overflow: ${(p) => (p.isFullPage ? 'visible' : 'hidden')};
  @media ${mobileSize} {
    margin-top: 8px;
  }
`
export const CardTabContainer = styled.div`
  padding: 24px;
  padding-top: 32px;
  background: #fff;
  @media ${tabletSize} {
    padding: 16px;
  }
  @media ${mobileSize} {
    border-radius: 8px;
    padding: 8px;
  }
`

const TablPanelContainer = styled.div`
  padding: 24px 8px;
`
const SkuInfoRowWapper = styled.div`
  display: flex;
  margin-bottom: 24px;
  align-items: flex-start;
  @media ${mobileSize} {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 16px;
  }
`
const LeftTitle = styled.div`
  width: 18.75%;
  min-width: 5em;
  max-width: 150px;
  color: ${(p) => p.theme.color.navigationTitleColor};
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  @media ${mobileSize} {
    font-size: 14px;
    width: 100%;
  }
`

const RightContent = styled.div`
  width: 81.25%;
  white-space: pre-line;
  color: #252525;
  font-size: 16px;
  line-height: 1.5;
  word-break: break-all;
  @media ${mobileSize} {
    font-size: 14px;
    padding-top: 4px;
    width: 100%;
  }
`
const ExpireLabel = styled.span`
  border-radius: 2px;
  background-color: ${(p) => p.theme.color.rosiness};
  font-size: 14px;
  color: #fff;
  padding: 2px 8px;
  margin-left: 8px;
  display: inline-block;
`
const TncText = styled.div`
  white-space: pre-line;
  color: #252525;
  font-size: 16px;
  line-height: 1.5;
  word-break: break-all;
`
export const Button = styled.div`
  position: relative;
  min-width: 160px;
  width: max-content;
  height: 48px;
  background-color: ${(props) =>
    props.disabled
      ? props.theme.color.disableButtonBgColor
      : props.theme.color.primary};
  border-radius: 4px;
  color: ${(props) =>
    props.disabled
      ? props.theme.color.disableButtonColor
      : props.theme.color.buttonColor};
  font-size: 16px;
  cursor: pointer;
  padding: 0 16px;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  &:active {
    background-color: #a2b5f9;
  }
  @media ${mobileSize} {
    width: 100%;
  }
`
export const ButtonTextWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-left: ${(p) => p.paddingLeft && '8px'};
  line-height: 1.5;
`

export default DetailCard
